<!--
 * @Descripttion: 
 * @version: 
 * @Author: pengmiaopei
 * @Date: 2021-07-24 15:21:44
 * @LastEditors: pengmiaopei
 * @LastEditTime: 2021-11-03 13:49:04
 * @Description: file content
 * @FilePath: \Design_Vue_pmp\src\components\DialogForm\components\DraggableItem.vue
-->
<template>
  <div>
    <el-col
      class="drawing-item"
      :class="{ 'active-from-item': activeIndex === index }"
      :span="element.span"
      v-bind="$attrs"
      v-on="$listeners"
      @click.native.stop="selectItem(element, index)"
    >
      <!--文本框 -->
      <template v-if="element.type === 'input'">
        <el-form-item :label="element.name" label-width="80px">
          <el-input
            v-model="element.options.defaultValue"
            :style="{ width: element.options.width }"
            :placeholder="element.options.placeholder"
          />
        </el-form-item>
      </template>
      <!-- 文本域 -->
      <template v-if="element.type === 'textarea'">
        <el-form-item :label="element.name" label-width="80px">
          <el-input
            v-model="element.options.defaultValue"
            :style="{ width: element.options.width }"
            :placeholder="element.options.placeholder"
            :type="element.type"
          />
        </el-form-item>
      </template>
      <span class="drawing-item-delete" style="visibility:visibility;" title="删除" @click="delItem(element)">
        <i class="el-icon-close" />
      </span>
    </el-col>
  </div>
</template>

<script>
  export default {
    name: 'DraggableItem',
    render(h) {
      return h
    },
    /* eslint-disable */
    props: ['element', 'index', 'activeIndex', 'drawingList'],
    data() {
      return {
        // selectIndex: null
      }
    },
    watch: {
      element: {
        handler(val) {},
        deep: true,
      },
      index(val) {},
    },
    methods: {
      selectItem(data, index) {
        this.$emit('activeItem', data, index)
      },
      delItem(data) {
        this.$emit('deleteItem', data)
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import '../styles/form.scss';
</style>
